import { type KeyboardEvent } from 'react'

export const isDeleteKeyboardEvent = (keyboardEvent: KeyboardEvent<HTMLSpanElement>) =>
  keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete'
